export const breakpoints = ['767px', '1056px', '1440px', '1919px'];
